<!--
* @copyright Chianyu Inc., 2025 and onwards
* @author Liwg
* @date  2025/6/6 12:10
* @des
-->
<template>
  <div class="home-content">
    <img class="logo-title" src="@/assets/images/padcontrol_logo_title.png">
    <div class="row-column">
      <div class="content-container">
        <div class="title-wrapper">
          <span class="top-title">{{ $t('padcontrol.appName') }}</span>
          <span class="top-subTitle">{{ $t('padcontrol.title0') }}</span>
        </div>
        <div class="img-container">
          <img class="home-preview" src="@/assets/images/padcontrol_home_preview1.png">
          <img class="home-preview" src="@/assets/images/padcontrol_home_preview2.png">
        </div>
      </div>
      <div class="mobile-button-wrapper">
        <span class="button-text" @click="downloadAndroidApp">Android下载</span>
        <span class="button-text" @click="downloadIOSApp">iOS下载</span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PadMobileOfficalView',
  components: {},
  data () {
    return {}
  },
  methods: {
    downloadAndroidApp () {
      this.$emit('downloadAndroidApp')
    },
    downloadIOSApp () {
      this.$emit('downloadIOSApp')
    }
  }
}
</script>

<style scoped>

.row-column {
  display: flex;
  flex-direction: column;
}

.home-content {
  display: flex;
  flex-direction: column;
  z-index: 1;
  flex: 1;
}

.logo-title {
  margin-left: 25px;
  margin-top: 15px;
  width: 125px;
  height: 30px;
}

.content-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-left: 30px;
  padding-right: 30px;
//background-color: blue;
}

.title-wrapper {
  display: flex;
  flex-direction: column;
//background-color: green;
}

.top-title {
  color: white;
  font-size: 22px;
  font-weight: bold;
  margin-top: 50px;
}

.top-subTitle {
  margin-top: 10px;
  margin-bottom: 50px;
  color: white;
  font-size: 16px;
}

.img-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.home-preview {
  width: 140px;
  height: 265px;
}

.mobile-button-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-left: 30px;
  padding-right: 30px;
  margin-top: 50px;
//background-color: red;
}

.button-text {
  border-radius: 8px;
  border-style: solid;
  border-color: #FFFFFF;
  border-width: 2px;
  color: #FFFFFF;
  width: 140px;
  height: 50px;
  font-size: 18px;
  line-height: 50px;
  font-weight: bold;
  text-align: center;
}

.button-text:active {
  background-color: #e3e5e5;
  color: #666666;
}
</style>



// WEBPACK FOOTER //
// src/pad-control/PadMobileOfficalView.vue